import { CFC } from "@api/types/cypress";
import React from "react";

const BoatingCardIcon: CFC = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <defs>
      <style>{`.cls-1{fill:#fff;}.cls-2{fill:#bcbec0;}.cls-3{fill:#cccccb;}.cls-4{fill:#b3b4b4;}.cls-5{fill:#666766;}`}</style>
    </defs>
    <g id="ICON_certs" data-name="ICON certs">
      <g id="Group_1291" data-name="Group 1291">
        <rect
          id="Rectangle_882"
          data-name="Rectangle 882"
          className="cls-1"
          x="0.9"
          y="10.71"
          width="59.81"
          height="37.88"
        />
        <g id="Group_1288" data-name="Group 1288">
          <g id="Group_1284" data-name="Group 1284">
            <circle id="Ellipse_30" data-name="Ellipse 30" className="cls-2" cx="10.6" cy="45.74" r="1.85" />
            <circle id="Ellipse_31" data-name="Ellipse 31" className="cls-2" cx="18" cy="45.74" r="1.85" />
            <circle id="Ellipse_32" data-name="Ellipse 32" className="cls-2" cx="14.3" cy="45.74" r="1.85" />
            <circle id="Ellipse_33" data-name="Ellipse 33" className="cls-2" cx="21.7" cy="45.74" r="1.85" />
            <circle id="Ellipse_34" data-name="Ellipse 34" className="cls-2" cx="29.1" cy="45.74" r="1.85" />
            <circle id="Ellipse_35" data-name="Ellipse 35" className="cls-2" cx="25.4" cy="45.74" r="1.85" />
            <circle id="Ellipse_36" data-name="Ellipse 36" className="cls-2" cx="32.8" cy="45.74" r="1.85" />
            <circle id="Ellipse_37" data-name="Ellipse 37" className="cls-2" cx="40.2" cy="45.74" r="1.85" />
            <circle id="Ellipse_38" data-name="Ellipse 38" className="cls-2" cx="36.5" cy="45.74" r="1.85" />
            <circle id="Ellipse_39" data-name="Ellipse 39" className="cls-2" cx="43.9" cy="45.74" r="1.85" />
            <circle id="Ellipse_40" data-name="Ellipse 40" className="cls-2" cx="51.29" cy="45.74" r="1.85" />
            <circle id="Ellipse_41" data-name="Ellipse 41" className="cls-2" cx="47.59" cy="45.74" r="1.85" />
          </g>
          <g id="Group_1285" data-name="Group 1285">
            <circle id="Ellipse_42" data-name="Ellipse 42" className="cls-2" cx="3.74" cy="38.89" r="1.85" />
            <circle id="Ellipse_43" data-name="Ellipse 43" className="cls-2" cx="3.74" cy="31.49" r="1.85" />
            <circle id="Ellipse_44" data-name="Ellipse 44" className="cls-2" cx="3.74" cy="35.19" r="1.85" />
            <circle id="Ellipse_45" data-name="Ellipse 45" className="cls-2" cx="3.74" cy="27.79" r="1.85" />
            <circle id="Ellipse_46" data-name="Ellipse 46" className="cls-2" cx="3.74" cy="20.39" r="1.85" />
            <circle id="Ellipse_47" data-name="Ellipse 47" className="cls-2" cx="3.74" cy="24.09" r="1.85" />
          </g>
          <g id="Group_1286" data-name="Group 1286">
            <circle id="Ellipse_48" data-name="Ellipse 48" className="cls-2" cx="51.17" cy="13.5" r="1.85" />
            <circle id="Ellipse_49" data-name="Ellipse 49" className="cls-2" cx="43.77" cy="13.5" r="1.85" />
            <circle id="Ellipse_50" data-name="Ellipse 50" className="cls-2" cx="47.47" cy="13.5" r="1.85" />
            <circle id="Ellipse_51" data-name="Ellipse 51" className="cls-2" cx="40.07" cy="13.5" r="1.85" />
            <circle id="Ellipse_52" data-name="Ellipse 52" className="cls-2" cx="32.67" cy="13.5" r="1.85" />
            <circle id="Ellipse_53" data-name="Ellipse 53" className="cls-2" cx="36.37" cy="13.5" r="1.85" />
            <circle id="Ellipse_54" data-name="Ellipse 54" className="cls-2" cx="28.97" cy="13.5" r="1.85" />
            <circle id="Ellipse_55" data-name="Ellipse 55" className="cls-2" cx="21.57" cy="13.5" r="1.85" />
            <circle id="Ellipse_56" data-name="Ellipse 56" className="cls-2" cx="25.27" cy="13.5" r="1.85" />
            <circle id="Ellipse_57" data-name="Ellipse 57" className="cls-2" cx="17.88" cy="13.5" r="1.85" />
            <circle id="Ellipse_58" data-name="Ellipse 58" className="cls-2" cx="10.48" cy="13.5" r="1.85" />
            <circle id="Ellipse_59" data-name="Ellipse 59" className="cls-2" cx="14.18" cy="13.5" r="1.85" />
          </g>
          <g id="Group_1287" data-name="Group 1287">
            <circle id="Ellipse_60" data-name="Ellipse 60" className="cls-2" cx="58.03" cy="20.36" r="1.85" />
            <circle id="Ellipse_61" data-name="Ellipse 61" className="cls-2" cx="58.03" cy="27.76" r="1.85" />
            <circle id="Ellipse_62" data-name="Ellipse 62" className="cls-2" cx="58.03" cy="24.06" r="1.85" />
            <circle id="Ellipse_63" data-name="Ellipse 63" className="cls-2" cx="58.03" cy="31.46" r="1.85" />
            <circle id="Ellipse_64" data-name="Ellipse 64" className="cls-2" cx="58.03" cy="38.86" r="1.85" />
            <circle id="Ellipse_65" data-name="Ellipse 65" className="cls-2" cx="58.03" cy="35.16" r="1.85" />
          </g>
          <path
            id="Path_148"
            data-name="Path 148"
            className="cls-2"
            d="M.91,10.71V48.59H60.72V10.71ZM58,45.85H3.68V13.45H58Z"
          />
          <path
            id="Path_149"
            data-name="Path 149"
            className="cls-2"
            d="M.9,10.71V18a5.52,5.52,0,0,0,7.33-2.7,5.57,5.57,0,0,0,0-4.59Z"
          />
          <path
            id="Path_150"
            data-name="Path 150"
            className="cls-2"
            d="M60.71,10.71H53.42a5.54,5.54,0,0,0,7.29,7.37Z"
          />
          <path
            id="Path_151"
            data-name="Path 151"
            className="cls-2"
            d="M60.71,48.58V41.3a5.52,5.52,0,0,0-7.36,7.28Z"
          />
          <path
            id="Path_152"
            data-name="Path 152"
            className="cls-2"
            d="M.9,48.58H8.18A5.53,5.53,0,0,0,.89,41.22Z"
          />
        </g>
        <g id="Group_1289" data-name="Group 1289">
          <path
            id="Rectangle_883"
            data-name="Rectangle 883"
            className="cls-3"
            d="M13.67,20.37H47.94a1.43,1.43,0,0,1,1.43,1.43h0a1.43,1.43,0,0,1-1.43,1.42H13.67a1.42,1.42,0,0,1-1.42-1.42h0A1.42,1.42,0,0,1,13.67,20.37Z"
          />
          <path
            id="Rectangle_884"
            data-name="Rectangle 884"
            className="cls-3"
            d="M13.67,26.37H47.94a1.42,1.42,0,0,1,1.43,1.42h0a1.43,1.43,0,0,1-1.43,1.43H13.67a1.42,1.42,0,0,1-1.42-1.43h0A1.41,1.41,0,0,1,13.67,26.37Z"
          />
          <path
            id="Rectangle_885"
            data-name="Rectangle 885"
            className="cls-3"
            d="M13.67,32.36H38.58A1.43,1.43,0,0,1,40,33.78h0a1.43,1.43,0,0,1-1.42,1.43H13.67a1.42,1.42,0,0,1-1.42-1.43h0A1.42,1.42,0,0,1,13.67,32.36Z"
          />
        </g>
        <g id="Group_1290" data-name="Group 1290">
          <path
            id="Path_153"
            data-name="Path 153"
            className="cls-4"
            d="M48.92,35.38l.68-1.06-1.12-.57.06-1.26-1.26.06-.57-1.12-1.07.68-1.06-.68L44,32.55l-1.26-.06.06,1.26-1.12.57.68,1.06-.68,1.06,1.12.58-.06,1.26L44,38.22l.57,1.12,1.07-.68,1.06.68.57-1.12,1.26.06L48.48,37l1.12-.58Zm-3.28,2.2a2.2,2.2,0,1,1,2.2-2.2,2.19,2.19,0,0,1-2.2,2.2Z"
          />
          <circle id="Ellipse_66" data-name="Ellipse 66" className="cls-4" cx="45.64" cy="35.38" r="1.55" />
        </g>
      </g>
      <g id="Group_1294" data-name="Group 1294">
        <rect
          id="Rectangle_886"
          data-name="Rectangle 886"
          className="cls-5"
          x="36.14"
          y="37.6"
          width="26.97"
          height="15.69"
          rx="1.23"
        />
        <rect
          id="Rectangle_887"
          data-name="Rectangle 887"
          className="cls-1"
          x="37.37"
          y="38.97"
          width="24.5"
          height="12.96"
          rx="0.61"
        />
        <rect
          id="Rectangle_888"
          data-name="Rectangle 888"
          className="cls-5"
          x="36.66"
          y="42.11"
          width="25.93"
          height="1.04"
        />
        <g id="Group_1293" data-name="Group 1293">
          <path
            id="Rectangle_889"
            data-name="Rectangle 889"
            className="cls-3"
            d="M46.83,44.42h12.6A.57.57,0,0,1,60,45h0a.57.57,0,0,1-.57.57H46.83a.57.57,0,0,1-.57-.57h0A.57.57,0,0,1,46.83,44.42Z"
          />
          <path
            id="Rectangle_890"
            data-name="Rectangle 890"
            className="cls-3"
            d="M46.83,46.81h12.6a.56.56,0,0,1,.57.56h0a.56.56,0,0,1-.57.57H46.83a.56.56,0,0,1-.57-.57h0A.56.56,0,0,1,46.83,46.81Z"
          />
          <path
            id="Rectangle_891"
            data-name="Rectangle 891"
            className="cls-3"
            d="M46.83,49.19H56a.56.56,0,0,1,.56.57h0a.56.56,0,0,1-.56.56H46.83a.56.56,0,0,1-.57-.56h0A.56.56,0,0,1,46.83,49.19Z"
          />
        </g>
        <rect
          id="Rectangle_892"
          data-name="Rectangle 892"
          className="cls-3"
          x="39.6"
          y="44.42"
          width="4.93"
          height="5.9"
        />
      </g>
    </g>
  </svg>
);

export default BoatingCardIcon;
